export type NavLink = {
  nameKey: string;
  label: string;
  path: string;
};

const LUNCH_MENU_URL = 'https://menu.checkpointcharly.everbranch.co/lunch/index.html';

export const NAV_LINKS: NavLink[] = [
  { nameKey: 'navigation.home', label: 'Home', path: '/' },
  { nameKey: 'navigation.about', label: 'About', path: '/about' },
  { nameKey: 'navigation.contact', label: 'Contacts', path: '/contact' },
  { nameKey: 'navigation.gallery', label: 'Gallery', path: '/gallery' },
  { nameKey: 'navigation.menu', label: 'Menu', path: '/menu' },
  { nameKey: 'navigation.lunchMenu', label: 'Lunch Menu', path: LUNCH_MENU_URL },
];
